import React, {useEffect, useState} from "react";
import './SensorDetails.scss'
import Spinner from "./_common/Spinner";
import SensorModal from "./SensorModal";

const SensorDetails = props => {
    const {sensor, fields, numberPerPage, filter, userId,loadSensors, isTabletOrLess} = props;
    const [pending, setPending] = useState(true)

    useEffect(() => {
      reload()
    },[sensor])

    const reload = () => {
        return new Promise((resolve) => {
            setPending(true)
            setTimeout(() => {
                setPending(false)
                resolve()
            }, 300)
        })
    }


    if(pending) {
        return (
            <div className='spinnerWrapper'>
                <Spinner size={300} />
            </div>
        )
    }

    return (
        <div className="SensorDetails">
            <SensorModal
                sensor={sensor}
                fields={fields}
                numberPerPage={numberPerPage}
                filter={filter}
                userId={userId}
                details
                reload={reload}
                loadSensors={loadSensors}
                isTabletOrLess={isTabletOrLess}
            />
        </div>
    )
}

export default SensorDetails
